import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { classNames } from '../classnames/index.esm.js';
import styles from '../../styles/uitk-egds-utils.css';

// eslint-disable-next-line
classNames.bind(styles);
const EGDSContext = React.createContext({
  context: null
});
const useEGDSContext = () => React.useContext(EGDSContext);
// Wrapping component and render prop so class components can access useEGDSContext
const EGDSContextWrapper = ({
  children
}) => {
  const {
    context,
    data
  } = useEGDSContext();
  return children(context, data);
};
const EGDSContextProvider = ({
  children,
  config
}) => jsx(EGDSContext.Provider, {
  value: config,
  children: children
});
EGDSContextProvider.displayName = 'EGDSContextProvider';
export { EGDSContext, EGDSContextProvider, EGDSContextWrapper, useEGDSContext };